// src/components/AboutUs.js

import React, { useState, useEffect } from 'react';

const AboutUs = () => {
    const [content, setContent] = useState({
        est_year: 'Est. 2024',
        est_city: 'Jodhpur',
        main_heading_1: 'Enabling',
        main_heading_2: 'Sustainable',
        main_heading_3: 'Growth',
        sub_text: 'India’s most trusted K–12 school ecosystem partner...',
        stats_years: '20+',
        who_we_are_text_1: 'Founded by education leaders...',
        who_we_are_text_2: 'Recognizing that schools...',
        vision_text: 'Empowering every K–12 institution...',
        mission_text: '"To enable schools to operate smarter..."'
    });

    useEffect(() => {
        fetch('/api/about/content')
            .then(res => res.json())
            .then(data => { if(data && data.est_year) setContent(data); })
            .catch(e => console.error(e));
    }, []);

    return (
        <div className="bg-white">
            {/* 1. HERO SECTION */}
            <section className="relative mt-4 pt-28 lg:pt-40 pb-20 lg:pb-35 px-6">
                <div className="max-w-7xl mx-auto text-center">
                    <div className="inline-flex items-center gap-3 bg-white px-5 py-2 rounded-full mb-8 shadow-sm border border-slate-100">
                        <span className="w-2 h-2 bg-brand-orange rounded-full animate-ping"></span>
                        <span className="text-[10px] font-black text-brand-dark uppercase tracking-[0.4em]">{content.est_year} • {content.est_city}</span>
                    </div>
                    <h1 className="text-5xl md:text-5xl font-black text-brand-dark tracking-tighter uppercase leading-[0.9] mb-8">
                        {content.main_heading_1} <br /> <span className="text-brand-orange italic">{content.main_heading_2} </span> {content.main_heading_3}
                    </h1>
                    <p className="text-xl md:text-2xl text-slate-400 font-medium max-w-3xl mx-auto italic leading-relaxed">
                        {content.sub_text}
                    </p>
                </div>
            </section>

            {/* 2. WHO WE ARE */}
            <section className="py-20 px-6 bg-white">
                <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 items-center">
                    <div className="relative">
                        <div className="absolute -inset-4 bg-brand-orange/10 rounded-[3rem] blur-2xl"></div>
                        <img src="https://jacknjillschool.org/uploads/leadership/leader-1768204842753.JPG" className="relative rounded-[3rem] shadow-2xl grayscale hover:grayscale-0 transition-all duration-1000" alt="Founders" />
                        <div className="absolute bottom-8 right-8 bg-brand-dark text-white p-8 rounded-[2rem] shadow-2xl">
                            <p className="text-4xl font-black text-brand-orange leading-none mb-1">{content.stats_years}</p>
                            <p className="text-[10px] font-black uppercase tracking-widest">Years Expertise</p>
                        </div>
                    </div>
                    <div className="space-y-8">
                        <h2 className="text-4xl md:text-6xl font-black text-brand-dark tracking-tighter uppercase italic leading-none">Who We <span className="text-brand-orange">Are</span></h2>
                        <p className="text-lg text-slate-500 font-medium leading-relaxed">
                            {content.who_we_are_text_1}
                        </p>
                        <p className="text-lg text-slate-500 font-medium leading-relaxed">
                            {content.who_we_are_text_2}
                        </p>
                        <div className="pt-4"><div className="w-20 h-1.5 bg-brand-orange rounded-full"></div></div>
                    </div>
                </div>
            </section>

            {/* 3. PILLARS (Static Layout) */}
            <section className="py-18 px-6 bg-slate-50">
                <div className="max-w-5xl mx-auto">
                    <div className="text-center mb-20">
                        <h2 className="text-4xl md:text-6xl font-black text-brand-dark tracking-tighter uppercase mb-6">Complete <span className="text-brand-orange italic">Ecosystem</span></h2>
                        <p className="text-slate-400 font-bold uppercase tracking-[0.3em] text-xs">Diagnosis to Execution</p>
                    </div>
                    <div className="grid md:grid-cols-3 gap-8">
                         {/* Card 1 */}
                        <div className="bg-white p-10 rounded-[3rem] shadow-xl border border-white hover:-translate-y-4 transition-all duration-500 group">
                            <div className="w-16 h-16 bg-brand-dark text-brand-orange rounded-2xl flex items-center justify-center mb-8 group-hover:bg-brand-orange group-hover:text-white transition-colors">
                                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 002 2h2a2 2 0 002-2" strokeWidth="2"/></svg>
                            </div>
                            <h3 className="text-2xl font-black text-brand-dark uppercase tracking-tight mb-4">Growth <br /> Diagnostic</h3>
                            <p className="text-sm text-slate-400 font-medium leading-relaxed">India’s first AI-Driven assessment identifying strengths, gaps, and risks across 7 critical domains</p>
                        </div>
                         {/* Card 2 */}
                        <div className="bg-brand-dark p-10 rounded-[3rem] shadow-xl hover:-translate-y-4 transition-all duration-500 group">
                            <div className="w-16 h-16 bg-brand-orange text-white rounded-2xl flex items-center justify-center mb-8">
                                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" strokeWidth="2"/></svg>
                            </div>
                            <h3 className="text-2xl font-black text-white uppercase tracking-tight mb-4">Service <br /> Deck</h3>
                            <p className="text-sm text-slate-300 font-medium leading-relaxed">50+ services across 11 specialized lines. From HR & Finance to Curriculum & Tech</p>
                        </div>
                        {/* Card 3 */}
                        <div className="bg-white p-10 rounded-[3rem] shadow-xl border border-white hover:-translate-y-4 transition-all duration-500 group">
                            <div className="w-16 h-16 bg-brand-dark text-brand-orange rounded-2xl flex items-center justify-center mb-8 group-hover:bg-brand-orange group-hover:text-white transition-colors">
                                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" strokeWidth="2"/></svg>
                            </div>
                            <h3 className="text-2xl font-black text-brand-dark uppercase tracking-tight mb-4">Procurement <br /> Hub</h3>
                            <p className="text-sm text-slate-400 font-medium leading-relaxed">A centralized platform for 300+ school essentials ensuring cost efficiency and reliability</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* 4. VISION & MISSION */}
            <section className="py-24 px-6 bg-brand-dark text-white relative overflow-hidden">
                <div className="absolute -right-20 -top-20 w-80 h-80 bg-brand-orange/10 rounded-full blur-[100px]"></div>
                <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-20">
                    <div>
                        <span className="text-brand-orange font-black uppercase tracking-[0.4em] text-[10px] mb-6 block">Our Vision</span>
                        <h2 className="text-4xl md:text-4xl font-black uppercase italic leading-[0.95] text-white">
                            To become India’s <br />
                            <span className="text-brand-orange">Most Trusted</span> <br />
                            Ecosystem
                        </h2>
                        <p className="text-xl text-slate-300 font-medium leading-relaxed border-l-4 border-brand-orange pl-8 mt-6">
                            Empowering every K–12 institution to deliver academic excellence and operational clarity
                        </p>
                    </div>
                    <div className="bg-white/5 backdrop-blur-lg p-12 rounded-[4rem] border border-white/10">
                        <span className="text-brand-orange font-black uppercase tracking-[0.4em] text-[10px] mb-6 block">Our Mission</span>
                        <p className="text-2xl font-bold leading-tight italic text-white mb-6">
                            "To enable schools to operate smarter, grow faster, and perform better"
                        </p>
                        <p className="text-slate-400 leading-relaxed">
                            Through AI-driven diagnostics and expert advisory, we help leaders make data-backed decisions for future-ready environments
                        </p>
                    </div>
                </div>
            </section>

            {/* 5. CORE VALUES (GRID) */}
            <section className="py-24 px-6 bg-white">
                <div className="max-w-7xl mx-auto">
                    <div className="mb-16">
                        <h2 className="text-4xl font-black text-brand-dark uppercase tracking-tighter">Core <span className="text-brand-orange italic">Values</span></h2>
                        <div className="w-16 h-1.5 bg-brand-orange mt-4 rounded-full"></div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-12 gap-y-16">
                        <div>
                            <span className="text-4xl font-black text-slate-200 block mb-4">01</span>
                            <h4 className="text-sm font-black text-brand-dark uppercase tracking-widest mb-3">School-First</h4>
                            <p className="text-xs text-slate-400 font-medium leading-relaxed">Institutional growth above short-term commercial gains</p>
                        </div>
                        <div>
                            <span className="text-4xl font-black text-slate-200 block mb-4">02</span>
                            <h4 className="text-sm font-black text-brand-dark uppercase tracking-widest mb-3">Integrity</h4>
                            <p className="text-xs text-slate-400 font-medium leading-relaxed">Transparency, accountability, and regulatory compliance are non-negotiable</p>
                        </div>
                        <div>
                            <span className="text-4xl font-black text-slate-200 block mb-4">03</span>
                            <h4 className="text-sm font-black text-brand-dark uppercase tracking-widest mb-3">Data-Driven</h4>
                            <p className="text-xs text-slate-400 font-medium leading-relaxed">Rooted in insights and analytics for clarity and confidence</p>
                        </div>
                        <div>
                            <span className="text-4xl font-black text-slate-200 block mb-4">04</span>
                            <h4 className="text-sm font-black text-brand-dark uppercase tracking-widest mb-3">Customization</h4>
                            <p className="text-xs text-slate-400 font-medium leading-relaxed">Tailored solutions that respect each school’s unique vision</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* 6. CTA PARTNER */}
            <section className="py-22 px-6 pb-20">
                <div className="max-w-5xl mx-auto bg-brand-orange rounded-[4rem] p-12 md:p-20 text-center relative overflow-hidden shadow-2xl">
                    <div className="absolute -left-10 -bottom-10 w-40 h-40 bg-white/10 rounded-full"></div>
                    <h2 className="text-4xl md:text-6xl font-black text-white uppercase tracking-tighter leading-none mb-8 relative z-10">
                        Partner with <br /> <span className="italic text-brand-dark">Acadfinity</span>
                    </h2>
                    <p className="text-brand-dark font-bold text-lg mb-12 max-w-2xl mx-auto relative z-10">
                        Join a growing network of schools transforming with clarity, confidence, and purpose. Let’s accelerate your growth together.
                    </p>
                    
                    <a href="https://acadfinity.com/school-register" className="inline-block bg-brand-dark text-white px-12 py-6 rounded-full text-[12px] font-black uppercase tracking-[0.3em] hover:scale-105 transition-transform shadow-2xl relative z-10">
                        Start Your Journey
                    </a>
                </div>
            </section>
        </div>
    );
};

export default AboutUs;